import {IMAGE_HOST} from "src/utils/constants";
import {CoverImage} from "src/model/api/cover-image.model";

export const CoverPage = (props: { coverImages: CoverImage[]; }) => {
  const { coverImages } = props;

  return coverImages?.length > 0 ? (
    <div className="cover-page">
      <img
        src={`${IMAGE_HOST}${coverImages[0].image}`}
        style={{
          width: "100%",
        }}
      />
    </div>
  ) : null;
};
